import Modal from 'components/Modal'
import LoyaltyAllocationReversalTx from 'views/MemberProfile/ManualTx/LoyaltyAllocationReversalTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalLoyaltyAllocationReversalTx = ({
  title,
  open,
  onClose,
}: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <LoyaltyAllocationReversalTx onClose={onClose} />
    </Modal>
  )
}

export default ModalLoyaltyAllocationReversalTx
